var _defs, _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDirtHand = function SvgIconDirtHand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.94 76.04"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-dirt_hand_svg__dirt_hand-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke:#9c431a;stroke-width:.73px}.icon-dirt_hand_svg__dirt_hand-3{fill:#d96243}.icon-dirt_hand_svg__dirt_hand-3,.icon-dirt_hand_svg__dirt_hand-4,.icon-dirt_hand_svg__dirt_hand-5{stroke-width:0}.icon-dirt_hand_svg__dirt_hand-4{fill:#90ba5e}.icon-dirt_hand_svg__dirt_hand-5{fill:#663a23}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1 23.33S27.4 8.07 47.04 0c0 0 4.55 14.72-10.95 23.33Z",
    className: "icon-dirt_hand_svg__dirt_hand-4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.99 22.8s-6.96-16.13-25.22-5.29c0 0 9.02 12.49 25.22 5.29",
    className: "icon-dirt_hand_svg__dirt_hand-4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.67 31.84s1.39-10.64-5.1-19.25",
    style: {
      stroke: "#13241d",
      strokeWidth: ".64px",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.82 43.28c-.4.29-7.32 1.85-7.32 1.85-2.73-.53-6.82.15-6.82.15-.72-.59-7.54-3.11-7.54-3.11-5.24-4.05-7.57-3.56-8.49-3.56-.57 0-2.18.53-2.47 1.23-.24.57-.06 1.27.41 1.64 4.06 3.2 14.7 11.44 17.4 12.52 2.89 1.16 15.69 1.4 15.69 1.4s.22-12.9-.85-12.12Z",
    className: "icon-dirt_hand_svg__dirt_hand-3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.2,
    cy: 42.75,
    r: 8.42,
    className: "icon-dirt_hand_svg__dirt_hand-5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.67,
    cy: 37.46,
    r: 8.42,
    className: "icon-dirt_hand_svg__dirt_hand-5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.41,
    cy: 42.41,
    r: 8.42,
    className: "icon-dirt_hand_svg__dirt_hand-5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.75 45.7c-.4.29-7.32 1.85-7.32 1.85-2.73-.53-6.82.15-6.82.15-.72-.59-7.54-3.11-7.54-3.11-5.24-4.05-7.57-3.56-8.49-3.56-.57 0-2.18.53-2.47 1.23-.24.57-.06 1.27.41 1.64 4.06 3.2 14.7 11.44 17.4 12.52 2.89 1.16 15.69 1.4 15.69 1.4s.22-12.9-.85-12.12Z",
    className: "icon-dirt_hand_svg__dirt_hand-3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.39 54.66s3.28-3.18 5.99-2.7c0 0 7.1-1.01 6.9-5.04-.06-1.3 12.92 1.02 12.15-3.53L46 39.91c11.91-.17 14.7 5.97 14.7 5.97l-7.2 13.93-22.89-2.23s-13.92-3.43-13.22-2.92",
    className: "icon-dirt_hand_svg__dirt_hand-3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.27 54.25c-.37-.75-2.79-3.61-6.23-3.41-2.6.15-3.42.39-4.78.64-3.15.58-4.87.52-6.48-.07-2.23-.81-2.66-3.06-1.84-3.43 2.33-1.05 6.72-2.17 9.03-2.88 2.5-.77 8.01-2.75 9.86-3.42.36-.13.7-.27 1.05-.43 1.28-.59 5.21-2.15 9.08-1.22l-9.68 14.21Z",
    className: "icon-dirt_hand_svg__dirt_hand-3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.64 49.43c-2.6.15-10.2 2.21-11.56 2.46-3.15.58-4.87.52-6.48-.07-2.23-.81-2.66-3.06-1.84-3.43l.92-.33M9.49 43.1l7.29 4.72",
    className: "icon-dirt_hand_svg__dirt_hand-2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.55 76.04 48.3 52.3l12.41-6.42 15.23 29.85z",
    className: "icon-dirt_hand_svg__dirt_hand-3"
  })));
};
export default SvgIconDirtHand;